// The chat title comes from the loaded chat and is rendered as text only, never
// injected as HTML.

import { isNumber, isString } from "../utils/schemaUtils";

export interface LoadChatPayload {
  type: "load_chat";
  version: number;
  chatId: string;
  chatTitle: string;
  error?: string;
}

export const parseLoadChatPayload = (v: unknown): LoadChatPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "load_chat") return null;
  if (!isNumber(r.version)) return null;
  if (!isString(r.chatId)) return null;
  if (!isString(r.chatTitle)) return null;
  if (r.error !== undefined && !isString(r.error)) return null;
  return {
    type: "load_chat",
    version: r.version,
    chatId: r.chatId,
    chatTitle: r.chatTitle,
    error: r.error,
  };
};
